import { ArrowAutofitDown20Filled, ArrowDown12Filled, ArrowDownFilled } from "@fluentui/react-icons";
import React from "react";

type CustomSelectProps = React.SelectHTMLAttributes<HTMLSelectElement> & {
    value: string;
    onChange: (e: React.ChangeEvent<HTMLSelectElement>) => void;
    className?: string;
};

export default function CustomSelect({
    value,
    onChange,
    children,
    className = "",
    ...props
}: CustomSelectProps) {
    return (
        <div className={`relative w-full ${className}`}>
            <select
                value={value}
                onChange={onChange}
                className={`
          appearance-none
          w-full h-full
          min-w-0 max-w-full
          bg-primary-light dark:bg-primary-dark
          text-primary-dark dark:text-primary-light
          text-left text-xs
          truncate
          outline-none
          
          pr-10 pl-4
        `}
                {...props}
            >
                {children}
            </select>
            <div className="pointer-events-none absolute right-2.5 top-1/2 -translate-y-1/2 flex flex-col leading-none text-gray-500 text-[10px]">

                <svg
                    className="w-4 h-4 text-primary-dark dark:text-primary-light"
                    fill="none"
                    stroke="currentColor"
                    strokeWidth="2"
                    viewBox="0 0 24 24"
                >
                    <path strokeLinecap="round" strokeLinejoin="round" d="M19 9l-7 7-7-7" />
                </svg>

            </div>
        </div>
    );
}